var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404-container"},[_c('mds-empty-state',{attrs:{"title":_vm.title,"message":_vm.message,"size":"large"},scopedSlots:_vm._u([(_vm.showIcon)?{key:"mds-empty-state-icon",fn:function(){return [_c('img',{attrs:{"src":require("../images/404-face.svg"),"role":"presentation"}})]},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }